import { render, staticRenderFns } from "./WineDetails.vue?vue&type=template&id=361e8822"
import script from "./WineDetails.vue?vue&type=script&lang=js"
export * from "./WineDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('361e8822')) {
      api.createRecord('361e8822', component.options)
    } else {
      api.reload('361e8822', component.options)
    }
    module.hot.accept("./WineDetails.vue?vue&type=template&id=361e8822", function () {
      api.rerender('361e8822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/WineDetails.vue"
export default component.exports